import React from 'react';
import PropTypes from 'prop-types';
import { ButtonToolbar } from 'reactstrap';
import EditButton from '../../../common/button/EditButton';
import { BUS_BODY_WORK_PATH } from '../../../../config/paths';
import BusBodyworkDeleteButton from './BusBodyworkDeleteButton';

const BusBodyworkToolbar = ({ busBodyWorkId }) => (
  <ButtonToolbar className="pull-right">
    <div>
      <EditButton path={`${BUS_BODY_WORK_PATH}/${busBodyWorkId}/edit`} />{' '}
      <BusBodyworkDeleteButton busBodyWorkId={busBodyWorkId} />
    </div>
  </ButtonToolbar>
);

BusBodyworkToolbar.propTypes = {
  busBodyWorkId: PropTypes.number.isRequired,
};

export default BusBodyworkToolbar;